import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import axios from 'axios';
import ErrorMessages from './profile';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import updatePasswordSchema from './schema';
import SuccessMessage from './success';
import ValidateLoader from '../UI/validateLoader';
import PasswordMessage from '../registration/passwordMessage';
import request, { apiHost } from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { addLocale } from '../misc';
import { directAccessConfigs } from '../utils/directAccessConfig';

const UpdatePassword = ({ history }) => {
     const locale = useLocaleContext();
      const addLocaleToUrl = addLocale(locale);
    
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const isPasswordChangeRequired = request.getPasswordUpdate();
  // eslint-disable-next-line no-unused-vars
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: {
          UPDATE_PASSWORD_HEADING,
          UPDATE_PASSWORD_MESSAGE,
          UPDATE_PASSWORD_NEW_PASSWORD,
          UPDATE_PASSWORD_CONFIRM_PASSWORD,
          UPDATE_PASSWORD_PLACEHOLDER_NEW_PASSWORD,
          UPDATE_PASSWORD_PLACEHOLDER_CONFIRM_PASSWORD,
          UPDATE_PASSWORD_UPDATE_MESSAGE,
          UPDATE_BUTTON_TITLE
        }
      }
    }
  } = locale === 'en-US' ? EN : FR;
  const updatePasswordRequest = values => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    const { newPassword } = values;
    const {
      location: { search }
    } = history;
    const queryParam = search.substr(6);
    axios
      .post(`${apiHost}/updatePassword`, { newPassword, code: queryParam })
      .then(() => {
        setTimeout(() => history.push('/login'), 3000);
        setLoading(false);
        setSuccess(true);
      })
      .catch(err => {
        const {
          data: { error }
        } = err && err.response;
        setError(error);
        setLoading(false);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const changePasswordRequest = values => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    const redirectAfterLoginUrl = localStorage.getItem('redirectAfterLogin');
    const isRedirectValid = localStorage.getItem('isRedirectValid');
    localStorage.removeItem('redirectAfterLogin');
    const matchedConfig = Object.values(directAccessConfigs).find(config =>
      Object.values(config.webformUrls).includes(redirectAfterLoginUrl)
    );
    let targetURL = '/login';

    if (matchedConfig && isRedirectValid) {
      targetURL = matchedConfig.redirectTo || '/login';
    }
    localStorage.setItem('isRedirectValid', false);
    const { newPassword } = values;
    request
      .post('/users/changePassword', { newPassword })
      .then(() => {
        localStorage.clear();
        setTimeout(() => history.push(addLocaleToUrl(targetURL)), 1000);
        setLoading(false);
        setSuccess(true);
      })
      .catch(err => {
        const {
          data: { error }
        } = err && err.response;
        setError(error);
        setLoading(false);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const onSubmit = values => {
    if (isPasswordChangeRequired) {
      changePasswordRequest(values);
    } else {
      updatePasswordRequest(values);
    }
  };

  return (
    <>
      <div id="main" style={{ marginBottom: '94px' }}>
        <div id="main-wrapper">
          <div style={{ paddingBottom: '22rem' }} id="main-content">
            <ErrorMessages error={isError} />
            <div id="main-content-steps">
              <span className="frg-body-font-14px">
                {!isPasswordChangeRequired && UPDATE_PASSWORD_HEADING}
              </span>
            </div>
            <div
              style={{ backgroundColor: '#57a708' }}
              id="main-content-indicator"
            >
              <div id="main-content-indicator-step-2"></div>
            </div>
            <div id="main-content-login">
              <Formik
                initialValues={{
                  newPassword: '',
                  confirmPassword: ''
                }}
                validationSchema={updatePasswordSchema}
                onSubmit={values => {
                  onSubmit(values);
                }}
              >
                {({ errors, touched }) => (
                  <Form>
                    <div>
                      <span className="frg-body-font-14px">
                        {UPDATE_PASSWORD_MESSAGE}
                      </span>
                    </div>

                    {isSuccess && <SuccessMessage />}
                    <div
                      id="username_container"
                      style={{ position: 'relative' }}
                    >
                      <div className="main-content-form-headers">
                        <span className="frg-body-font-14px">
                          {UPDATE_PASSWORD_NEW_PASSWORD}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${
                          errors.newPassword && touched.newPassword
                            ? 'error'
                            : ''
                        }`}
                      >
                        <Field
                          type="password"
                          name="newPassword"
                          style={{ width: '100%' }}
                          className="select-style"
                          placeholder={UPDATE_PASSWORD_PLACEHOLDER_NEW_PASSWORD}
                        />

                        <>
                          <div className="error_messages">
                            <span className="frg-body-font-14px">
                              {errors.newPassword}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </div>

                    <div style={{ marginTop: 15, position: 'relative' }}>
                      <div className="main-content-form-headers">
                        <span className="frg-body-font-14px">
                          {UPDATE_PASSWORD_CONFIRM_PASSWORD}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${
                          errors.confirmPassword && touched.confirmPassword
                            ? 'error'
                            : ''
                        }`}
                      >
                        <Field
                          type="password"
                          name="confirmPassword"
                          style={{ width: '100%' }}
                          className="select-style"
                          placeholder={
                            UPDATE_PASSWORD_PLACEHOLDER_CONFIRM_PASSWORD
                          }
                        />
                        <>
                          <div className="error_messages">
                            <span className="frg-body-font-14px">
                              {errors.confirmPassword}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </div>
                    <PasswordMessage />
                    {loading && (
                      <ValidateLoader
                        message={UPDATE_PASSWORD_UPDATE_MESSAGE}
                      />
                    )}
                    <div style={{ marginTop: 20 }}>
                      <span>
                        <button
                          type="submit"
                          className="frg-button button-wide color-green"
                        >
                          {UPDATE_BUTTON_TITLE}
                        </button>
                      </span>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

UpdatePassword.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    location: PropTypes.object.isRequired
  }).isRequired
};

export default UpdatePassword;
